import { FC } from 'react';
import { RootStyled } from './style';
import { Props } from './types';

const Root: FC<Props & { children?: any }> = ({ children, ...restProps }) => (
  <RootStyled {...restProps}>{children}</RootStyled>
);

export default Root;
